import {APP_BASE_HREF} from '@angular/common';
import {Component, ElementRef, Inject, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {share, tap} from 'rxjs/operators';
import {AuthService} from '../../shared/auth.service';
import {ClientApiService} from '../client-api.service';

@Component({
  selector: 'notes-panel',
  templateUrl: './notes-panel.component.html',
  styleUrls: ['./notes-panel.component.scss']
})
export class NotesPanelComponent implements OnChanges {

  @Input() submittal: Submittal;

  @ViewChild('text') text: ElementRef;

  user$ = this.Auth.user$;
  notes$: Observable<Note[]>;
  loading = true;
  masquerading$ = this.Auth.masquerading$;

  constructor(private Auth: AuthService,
              private Api: ClientApiService,
              @Inject(APP_BASE_HREF) private basePath: string) {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.loadNotes();
  }

  saveNote(text: string) {
    this.Api.addNote(this.submittal.orderId, text, {
      linkUrl: location.pathname.substr(this.basePath.length - 1),
      linkText: this.submittal.profile.profileName
    }).subscribe(() => {
      this.text.nativeElement.value = '';
      this.loadNotes();
    }, err => console.error('Failed to save note', err));
  }

  deleteNote(id: number) {
    this.Api.deleteNote(this.submittal.orderId, id)
      .subscribe(() => this.loadNotes(),
        err => console.error('Failed to delete note', err));
  }

  noteId(note: Note) {
    return note.id;
  }

  private loadNotes() {
    this.notes$ = this.Api.getNotes(this.submittal.orderId).pipe(
      tap(() => this.loading = false),
      share()
    );
  }
}
